import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/pay-monthly-compensates', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/pay-monthly-compensates', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, options = {}) => {
  return httpClient
    .get(`/api/pay-monthly-compensates/${id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/pay-monthly-compensates/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/pay-monthly-compensates/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getItemCompensate = (Option = {}) => {
  return httpClient
    .get(
      '/api/pay-item-compensates?page=-1&include=item_custom_rule&fields[pay_item_compensate]=compensate_id,compensate_item,custom_keyword&filter[item_type]=3&fields[item_custom_rule]=keyword,custom_rule,item_type_id'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getEmployeeCompensateList = (options = {}) => {
  return httpClient
    .get('/api/pay-monthly-compensates/import-custom-compensates', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const importCompensate = data => {
  return httpClient
    .post('/api/pay-monthly-compensates/import-custom-compensates', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, find, update, destroy, getItemCompensate, getEmployeeCompensateList, importCompensate }
